import { loadAsyncComponent } from 'src/components/AsyncComponent';

// TODO: do we need this view to be async?
export const SelectLanguagePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "SelectLanguagePopup" */ './View'),
  'popup'
);
